// extracted by mini-css-extract-plugin
module.exports = {"menu":"fb6c8e7715477066840ee8c29743e485-less"};